__turbopack_context__.v({
  "bottom": "drawer-module-scss-module__E-qmxG__bottom",
  "close": "drawer-module-scss-module__E-qmxG__close",
  "closeButton": "drawer-module-scss-module__E-qmxG__closeButton",
  "content": "drawer-module-scss-module__E-qmxG__content",
  "drawer": "drawer-module-scss-module__E-qmxG__drawer",
  "header": "drawer-module-scss-module__E-qmxG__header",
  "isFull": "drawer-module-scss-module__E-qmxG__isFull",
  "noPadding": "drawer-module-scss-module__E-qmxG__noPadding",
  "overlay": "drawer-module-scss-module__E-qmxG__overlay",
  "right": "drawer-module-scss-module__E-qmxG__right",
  "round": "drawer-module-scss-module__E-qmxG__round",
  "title": "drawer-module-scss-module__E-qmxG__title",
  "wrapper": "drawer-module-scss-module__E-qmxG__wrapper",
});
